import registrationStep from "../../registrationStep";
import SignaturePage from "./SignaturePage";

export default registrationStep(SignaturePage, "signature", "range-rules");



// WEBPACK FOOTER //
// ./src/registration/components/Signature/index.js